
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComPaList as ObiComPaListElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-pa-list.js';
 
 
 

 
 export const ObiComPaList = createComponent({
   react: React,
   tagName: 'obi-com-pa-list',
   elementClass: ObiComPaListElement,
   events: {
     
   }
  });
 
 